import React, { useState } from 'react';
import './App.css';
import NewPlayerForm from './NewPlayerForm';
import PlayerList from './PlayerList'
import PlayButton from './PlayButton';
import Reset from './Reset';
import GameState from './GameState';
import PlayersAndScores from './PlayersAndScores';
import shuffle from './shuffle';
import RollButton from './RollButton';
import KeepButton from './KeepButton';
import Dicetray from './Dicetray';
import DisplayCurrentTotal from './DisplayCurrentTotal.jsx';
import Pig from './Pig';
import BigPig from './BigPig';

function App() {
  // set players to be a blank array initially
  const [players, setPlayers] = useState([]);

  function addPlayer (name, color) {
    setPlayers(currentPlayers => {return [...currentPlayers, { id:crypto.randomUUID(), name:name, score:0, lastTurn:false, color:color}]});
  }

  function deletePlayer (id) {
    setPlayers(currentPlayers => {return currentPlayers.filter(player => player.id !== id)})
  }

  function shufflePlayers () {
    const shuffledPlayers=shuffle([...players]);
    setPlayers(shuffledPlayers);
  }

  function updateScore () {
    const oldScore = players[playersTurn].score;
    const newScore = oldScore + currentTotal;
    let copyOfPlayers = [...players];
    copyOfPlayers[playersTurn].score = newScore;
    setPlayers(copyOfPlayers);
    
  }

  function resetCurrentPlayerScore() {
    const copyOfPlayers = [...players];
    copyOfPlayers[playersTurn].score = 0;
    setPlayers(copyOfPlayers);
  }

  function resetScores () {
    let copyOfPlayers = [...players];
    for (let player in copyOfPlayers) {
      copyOfPlayers[player].score=0;
    }
    setPlayers(copyOfPlayers);
  }

  const [play, setPlay] = useState(false);

  function togglePlay () {
    setPlay(!play);
  }

  const [currentRoll, setCurrentRoll] = useState([0,0]);

  function resetRoll () {
    setCurrentRoll([0,0])
  } 

  function handleRoll(roll){
    setCurrentRoll(roll);
  }

  const [currentTotal, setCurrentTotal] = useState(0);

  function resetCurrentTotal() {
    setCurrentTotal(0);
  }

  function updateCurrentTotal(arrayOfTwoIntegers){
    if (arrayOfTwoIntegers[0] === 6 && arrayOfTwoIntegers[1] === 6) {
      pigOff();
      bigPigOn();
      resetCurrentTotal();
      resetCurrentPlayerScore();
      nextTurn();
}
    else if (arrayOfTwoIntegers.includes(6)) {
      bigPigOff();
      pigOn();
      resetCurrentTotal();
      nextTurn();
    }
    else {
      bigPigOff();
      pigOff();
      let interimTotal = arrayOfTwoIntegers.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
      setCurrentTotal((prev) => prev + interimTotal);
    }
  }

  const [playersTurn, setPlayersTurn] = useState(0);

  function resetTurn(){
    setPlayersTurn (0);
  }

  const [endGame, setEndGame] = useState(false);
  const [countDown, setCountDown] = useState(null);
  const [gameOver, setGameOver] = useState(false);
  const [winningPlayerIndex, setWinningPlayerIndex] = useState(0);

  function calculateWinner () {
    let playerScoreArray = [];
    for (let player in players) {
      playerScoreArray = [...playerScoreArray, players[player].score];
      console.log(`Player score array: ${playerScoreArray}`);
    }
    console.log(Math.max(...playerScoreArray));
    setWinningPlayerIndex(playerScoreArray.indexOf(Math.max(...playerScoreArray)));
    console.log(`winningPlayerIndex:${winningPlayerIndex}`);
  }

  function checkForEndGame() {
    if (players[playersTurn].score >= 100 && endGame !== true) {
      setEndGame(true);
      setCountDown(players.length-2);
    }
  }

  function nextTurn () {
    checkForEndGame();

    if (endGame) {
      setCountDown(previousCountDown => previousCountDown -1);
    }

    if (countDown === 0) {
      setEndGame(false);
      setGameOver(true);
      calculateWinner();
    }

    
    // Note the -1 is needed to stop overflow
    if (!gameOver){
      if (playersTurn < players.length -1 ) {
        setPlayersTurn ((prev) => prev + 1)
        }
      else {
        resetTurn();
        }
      }
    }

    function newGame () {
      setEndGame(false);
      setGameOver(false);
      pigOff();
    }
    
    const [pig, setPig] = useState(false);

    function pigOn () {
      setPig(true);
    }

    function pigOff () {
      setPig(false)
    }

    const [bigPig, setBigPig] = useState(false);

    function bigPigOn () {
      setBigPig (true);
    }

    function bigPigOff () {
      setBigPig (false);
    }


  
  return (
    <div className="App">
      {play === false && <NewPlayerForm addPlayer={addPlayer}/>}
      {play === false && <PlayerList players={players} deletePlayer={deletePlayer}/>}
      {play === false && players.length > 0 && <PlayButton togglePlay={togglePlay} shufflePlayers={shufflePlayers} />}
      {play === true && <>
        <GameState 
          players={players} 
          playersTurn={playersTurn} 
          endGame={endGame} 
          gameOver={gameOver} 
          winningPlayerIndex={winningPlayerIndex}/>
        <PlayersAndScores players={players}/>
        <Dicetray currentRoll={currentRoll}/>
        <DisplayCurrentTotal currentTotal={currentTotal}/>
        <div className="ButtonDiv">
        <RollButton 
          handleRoll={handleRoll} 
          updateCurrentTotal={updateCurrentTotal} 
          players={players}
          playersTurn={playersTurn}
          gameOver={gameOver}
          pigOn={pigOn}
          pigOff={pigOff}/>

        <KeepButton currentTotal={currentTotal} updateScore={updateScore} nextTurn={nextTurn} resetRoll={resetRoll} resetCurrentTotal={resetCurrentTotal}/>
        {pig && <Pig></Pig>}
        {bigPig && <BigPig></BigPig>}
        <Reset togglePlay={togglePlay} resetRoll={resetRoll} resetCurrentTotal={resetCurrentTotal} resetTurn={resetTurn} resetScores={resetScores} newGame={newGame}/>
        </div>
        </>
        }
    </div>
  )

}

export default App;
      
